<div id="toast-container" class="fixed top-4 end-4 z-50 w-64"></div>
<button (click)="toggleSidebar()" aria-controls="logo-sidebar" type="button"
  class="fixed left-4 top-4 items-center p-1.5 text-sm text-gray-500 border border-primary-700 rounded-lg lg:hidden group group hover:bg-primary-700 focus:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 z-50">
  <span class="sr-only">Open sidebar</span>
  <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path clip-rule="evenodd" fill-rule="evenodd"
      class="text-primary-700 group-hover:text-primary-50 focus:text-primary-50"
      d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z">
    </path>
  </svg>
</button>

<aside id="logo-sidebar"
  class="fixed top-0 left-0 z-40 w-56 lg:w-64 h-screen pt-20 transition-transform bg-white border-r border lg:translate-x-0 dark:bg-primary-800 dark:border-primary-700"
  [ngClass]="{
    'translate-x-0 transform-none': isSidebarOpen,
    '-translate-x-full': !isSidebarOpen
  }" aria-label="Sidebar">
  <div class="h-full pb-4 overflow-y-auto bg-white dark:bg-primary-800">
    <ul>
      <li>
        <a (click)="closeSidebar()" routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
          [routerLink]="['/locker']"
          class="flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
          <svg class="w-6 h-6 text-primary-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd"
              d="M10 5a2 2 0 0 0-2 2v3h2.4A7.48 7.48 0 0 0 8 15.5a7.48 7.48 0 0 0 2.4 5.5H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h1V7a4 4 0 1 1 8 0v1.15a7.446 7.446 0 0 0-1.943.685A.999.999 0 0 1 12 8.5V7a2 2 0 0 0-2-2Z"
              clip-rule="evenodd" />
            <path fill-rule="evenodd"
              d="M10 15.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm6.5-1.5a1 1 0 1 0-2 0v1.5a1 1 0 0 0 .293.707l1 1a1 1 0 0 0 1.414-1.414l-.707-.707V14Z"
              clip-rule="evenodd" />
          </svg>
          <span class="ms-3">Locker Management</span>
        </a>
      </li>
      <li>
        <a (click)="closeSidebar()" routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
          [routerLink]="['/claim-management']"
          class="flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
          <svg class="w-6 h-6 text-primary-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd"
              d="M12 2c-.791 0-1.55.314-2.11.874l-.893.893a.985.985 0 0 1-.696.288H7.04A2.984 2.984 0 0 0 4.055 7.04v1.262a.986.986 0 0 1-.288.696l-.893.893a2.984 2.984 0 0 0 0 4.22l.893.893a.985.985 0 0 1 .288.696v1.262a2.984 2.984 0 0 0 2.984 2.984h1.262c.261 0 .512.104.696.288l.893.893a2.984 2.984 0 0 0 4.22 0l.893-.893a.985.985 0 0 1 .696-.288h1.262a2.984 2.984 0 0 0 2.984-2.984V15.7c0-.261.104-.512.288-.696l.893-.893a2.984 2.984 0 0 0 0-4.22l-.893-.893a.985.985 0 0 1-.288-.696V7.04a2.984 2.984 0 0 0-2.984-2.984h-1.262a.985.985 0 0 1-.696-.288l-.893-.893A2.984 2.984 0 0 0 12 2Zm3.683 7.73a1 1 0 1 0-1.414-1.413l-4.253 4.253-1.277-1.277a1 1 0 0 0-1.415 1.414l1.985 1.984a1 1 0 0 0 1.414 0l4.96-4.96Z"
              clip-rule="evenodd" />
          </svg>
          <span class="ms-3">Claim Management</span>
        </a>
      </li>
      <li>
        <a (click)="closeSidebar()" routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
          [routerLink]="['/announcement']"
          class="flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
          <svg class="w-6 h-6 text-primary-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd"
              d="M18.458 3.11A1 1 0 0 1 19 4v16a1 1 0 0 1-1.581.814L12 16.944V7.056l5.419-3.87a1 1 0 0 1 1.039-.076ZM22 12c0 1.48-.804 2.773-2 3.465v-6.93c1.196.692 2 1.984 2 3.465ZM10 8H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6V8Zm0 9H5v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3Z"
              clip-rule="evenodd" />
          </svg>

          <span class="ms-3">Announcement Management</span>
        </a>
      </li>

      <li>
        <a (click)="closeSidebar()" routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
          [routerLink]="['/visitor-management']"
          class="flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
          <svg class="w-6 h-6 text-primary-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd"
              d="M4.998 7.78C6.729 6.345 9.198 5 12 5c2.802 0 5.27 1.345 7.002 2.78a12.713 12.713 0 0 1 2.096 2.183c.253.344.465.682.618.997.14.286.284.658.284 1.04s-.145.754-.284 1.04a6.6 6.6 0 0 1-.618.997 12.712 12.712 0 0 1-2.096 2.183C17.271 17.655 14.802 19 12 19c-2.802 0-5.27-1.345-7.002-2.78a12.712 12.712 0 0 1-2.096-2.183 6.6 6.6 0 0 1-.618-.997C2.144 12.754 2 12.382 2 12s.145-.754.284-1.04c.153-.315.365-.653.618-.997A12.714 12.714 0 0 1 4.998 7.78ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
              clip-rule="evenodd" />
          </svg>
          <span class="ms-3">Visitor Management</span>
        </a>
      </li>
      <li>
        <a (click)="closeSidebar()" routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
          [routerLink]="['/banner-management']"
          class="flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
          <svg class="w-6 h-6 text-primary-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd"
              d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm4.996 2a1 1 0 0 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM11 8a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm-4.004 3a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM11 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm-4.004 3a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM11 14a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z"
              clip-rule="evenodd" />
          </svg>


          <span class="ms-3">Banner Management</span>
        </a>
      </li>

      <li>
        <a (click)="closeSidebar()" routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
          [routerLink]="['/audio-announcement']"
          class="flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
          <svg version="1.1" class="w-6 h-6 text-primary-800 dark:text-white font-semibold"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24"
            id="Layer_1" x="0" y="0" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32" xml:space="preserve"
            fill="currentColor">
            <style></style>
            <path
              d="M16 27.308c-5.514 0-10-4.487-10-10a1 1 0 1 1 2 0c0 4.41 3.589 8 8 8s8-3.59 8-8a1 1 0 1 1 2 0c0 5.513-4.486 10-10 10z" />
            <path
              d="M16 24c-3.309 0-6-2.691-6-6V6c0-3.309 2.691-6 6-6s6 2.691 6 6v12c0 3.309-2.691 6-6 6zm0-22c-2.206 0-4 1.794-4 4v12c0 2.206 1.794 4 4 4s4-1.794 4-4V6c0-2.206-1.794-4-4-4zM21 32H11a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2z" />
            <path
              d="M16 32a1 1 0 0 1-1-1v-4.692a1 1 0 1 1 2 0V31a1 1 0 0 1-1 1zM21 8.938h-3.246a1 1 0 1 1 0-2H21a1 1 0 1 1 0 2zM21 13h-3.246a1 1 0 1 1 0-2H21a1 1 0 1 1 0 2zM21 17.063h-3.246a1 1 0 1 1 0-2H21a1 1 0 1 1 0 2zM14.246 8.938H11a1 1 0 1 1 0-2h3.246a1 1 0 1 1 0 2zM14.246 13H11a1 1 0 1 1 0-2h3.246a1 1 0 1 1 0 2zM14.246 17.063H11a1 1 0 1 1 0-2h3.246a1 1 0 1 1 0 2z" />
          </svg>




          <span class="ms-3">Audio Announcement</span>
        </a>
      </li>

      <li>

      <li>
        <a (click)="toggleManagementSubMenu()"
          routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
          class="cursor-pointer flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
          <!-- Optional: An icon for management -->
          <svg class="w-6 h-6 text-primary-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd"
              d="M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4Zm12 12V5H7v11h10Zm-5 1a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
              clip-rule="evenodd" />
          </svg>
          <span class="ms-3">App Management</span>
          <!-- Optional: An arrow icon to indicate expandable menu -->
          <svg class="w-4 h-4 ml-auto" [ngClass]="{ 'rotate-90': showManagementSubMenu }"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </a>

        <ul *ngIf="showManagementSubMenu" class="pl-6">
          <li>
            <a (click)="closeSidebar()" routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
              [routerLink]="['/app-management']"
              class="flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
              <svg class="w-6 h-6 text-primary-800 dark:text-white" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9.143 4H4.857A.857.857 0 0 0 4 4.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 10 9.143V4.857A.857.857 0 0 0 9.143 4Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 20 9.143V4.857A.857.857 0 0 0 19.143 4Zm-10 10H4.857a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286a.857.857 0 0 0 .857-.857v-4.286A.857.857 0 0 0 9.143 14Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286a.857.857 0 0 0 .857-.857v-4.286a.857.857 0 0 0-.857-.857Z" />
              </svg>

              <span class="ms-3">App Platform</span>
            </a>
          </li>
          <li>
            <a (click)="closeSidebar()" routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
              [routerLink]="['/app-message']"
              class="flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
              <svg class="w-6 h-6 text-primary-800 dark:text-white" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 9h5m3 0h2M7 12h2m3 0h5M5 5h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-6.616a1 1 0 0 0-.67.257l-2.88 2.592A.5.5 0 0 1 8 18.477V17a1 1 0 0 0-1-1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z" />
              </svg>

              <span class="ms-3">App Message</span>
            </a>
          </li>
          <li>
            <a (click)="closeSidebar()" routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
              [routerLink]="['/app-announcement']"
              class="flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
              <svg class="w-6 h-6 text-primary-800 dark:text-white" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M11 9H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6m0-6v6m0-6 5.419-3.87A1 1 0 0 1 18 5.942v12.114a1 1 0 0 1-1.581.814L11 15m7 0a3 3 0 0 0 0-6M6 15h3v5H6v-5Z" />
              </svg>
              <span class="ms-3">App Announcement</span>
            </a>
          </li>
          <li>
            <a (click)="closeSidebar()" routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
              [routerLink]="['/app-notification']"
              class="flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
              <svg class="w-6 h-6 text-primary-800 dark:text-white" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m10.827 5.465-.435-2.324m.435 2.324a5.338 5.338 0 0 1 6.033 4.333l.331 1.769c.44 2.345 2.383 2.588 2.6 3.761.11.586.22 1.171-.31 1.271l-12.7 2.377c-.529.099-.639-.488-.749-1.074C5.813 16.73 7.538 15.8 7.1 13.455c-.219-1.169.218 1.162-.33-1.769a5.338 5.338 0 0 1 4.058-6.221Zm-7.046 4.41c.143-1.877.822-3.461 2.086-4.856m2.646 13.633a3.472 3.472 0 0 0 6.728-.777l.09-.5-6.818 1.277Z" />
              </svg>
              <span class="ms-3">App Notification</span>
            </a>
          </li>
          <li>
            <a (click)="closeSidebar()" routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
              [routerLink]="['/reports']"
              class="flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
              <svg class="w-6 h-6 text-primary-800 dark:text-white" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-3 5h3m-6 0h.01M12 16h3m-6 0h.01M10 3v4h4V3h-4Z" />
              </svg>
              <span class="ms-3">Reports</span>
            </a>
          </li>
        </ul>
      </li>
      <li>
        <a (click)="closeSidebar()" routerLinkActive="text-[#d2ac2f] font-medium sidebar--active bg-[#fce9c5]"
          [routerLink]="['/newsletter-management']"
          class="flex items-center p-2 py-4 text-sm lg:text-base text-[#d2ac2f] hover:text-[#d2ac2f] hover:font-medium font-sans group border-l-[5px] border-transparent border-solid hover:border-[#d2ac2f] focus:border-[#d2ac2f] hover:bg-[#fce9c5]">
          <svg class="w-6 h-6 text-primary-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd"
              d="M9 2.221V7H4.221a2 2 0 0 1 .365-.5L8.5 2.586A2 2 0 0 1 9 2.22ZM11 2v5a2 2 0 0 1-2 2H4v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-7ZM8 16a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1-5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
              clip-rule="evenodd" />
          </svg>
          <span class="ms-3">Newsletter Management</span>
        </a>
      </li>
    </ul>
  </div>
</aside>

<!-- Overlay -->
<div *ngIf="isSidebarOpen" class="fixed inset-0 z-30 bg-black opacity-50" (click)="closeSidebar()"></div>